import extend from 'lodash/extend';

import api from '@ihme/common/api';
import request from '@ihme/common/api-request';
import { Filters } from '@ihme/common/types';

import config from './config';

api.setApiUrl(config.apiUrl);

export default extend(api, {
    data: {
        getCauseOutcomeRecords: (filters: Filters) =>
            request.get('data/cause-outcome', filters, { timeout: 100000 }),

        getCauseOutcomeFilters: (params?: object) =>
            request.get('data/cause-outcome-filters', params, { timeout: 100000 }),

        getRiskAttribution: (filters: Filters) =>
            request.get('data/risk-attribution', filters, { timeout: 100000 }),

        getRiskAttributionFilters: (params?: object) =>
            request.get('data/risk-attribution-filters', params, { timeout: 100000 }),
    },

    getExtendedCauses: (search = '', page = 1, per_page = 66) =>
        request.get(`extended-causes`, { search, page, per_page }),
});
